import { render, staticRenderFns } from "./drugDetails.vue?vue&type=template&id=5f14a304&scoped=true&"
import script from "./drugDetails.vue?vue&type=script&lang=js&"
export * from "./drugDetails.vue?vue&type=script&lang=js&"
import style0 from "./drugDetails.vue?vue&type=style&index=0&id=5f14a304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f14a304",
  null
  
)

export default component.exports